import React from 'react';
import styled from 'App/styled';
import {
  ActiveFilter,
  ActiveFilterData,
} from '@nykaa/listing-shared/type/filter';
import Pill from './pill';
import {
  getActiveFilterList,
  removeSelectedFiiter,
  extractActiveParamsForSearch,
} from 'helpers/filters';
import { PRICE_RANGE_FILTER } from '@nykaa/price-filter-shared/constants';

const Wrapper = styled.div`
  margin-bottom: 16px;
  width: 100%;
  box-shadow: 0 1px 3px rgba(226, 226, 226, 0.25),
    0 1px 2px rgba(226, 226, 226, 0.5);
  border-radius: 4px;
  background: #fff;
  padding: 0 16px;
`;
const ApplyTitle = styled.div`
  height: 100%;
  width: 100%;
  justify-content: space-between;
  position: relative;
  display: flex;
  align-items: center;
  ${({ theme }) => theme.typography.bodyMedium};
  padding: 16px 0;
  .name {
    text-transform: capitalize;
    ${({ theme }) => theme.typography.subTitleLarge};
  }
  .filter-clear-all {
    border: none;
    background: #fff;
    cursor: pointer;
    ${({ theme }) => theme.typography.buttonLarge};
    text-transform: capitalize;
    color: ${(props) => props.theme.brandPrimary};
  }
`;
const FilterList = styled.ul`
  display: flex;
  flex-wrap: wrap;
  list-style: none;
  margin: 0;
  padding: 0;
`;

interface SelectedFiltersProps {
  activeFilters: { [key: string]: ActiveFilter | string | number };
  changeFilter: (
    param: { [key: string]: ActiveFilter | string | number },
    isClearAll?: boolean
  ) => void;
}
const SelectedFilters = ({
  activeFilters,
  changeFilter,
}: SelectedFiltersProps) => {
  const activeFilterList = getActiveFilterList(activeFilters);
  const showSelectedFilters = activeFilterList?.length > 0;
  if (!showSelectedFilters) {
    return null;
  }
  const clearAllFilters = () => {
    const activeParamsOtherThanFilters =
      extractActiveParamsForSearch(activeFilters);
    changeFilter(activeParamsOtherThanFilters, true);
  };
  const handleCross = (filter: ActiveFilterData) => {
    let isPriceRangeFilter = filter.key === PRICE_RANGE_FILTER;
    const newFilters = removeSelectedFiiter(activeFilters, filter);
    changeFilter(newFilters, isPriceRangeFilter);
  };
  return (
    <Wrapper>
      <ApplyTitle>
        <span className="name">Filters Applied</span>
        <button
          className="filter-clear-all"
          onClick={clearAllFilters}
        >
          clear all
        </button>
      </ApplyTitle>
      <FilterList role="list">
        {activeFilterList.map((filter, idx) => (
          <Pill
            key={`${idx}-pill`}
            idx={idx}
            filter={filter}
            handleCross={handleCross}
          />
        ))}
      </FilterList>
    </Wrapper>
  );
};

export default SelectedFilters;
